export const notesConstants = {
    FETCH_NOTES: 'FETCH_NOTES',
    FETCH_NOTE: 'FETCH_NOTE',
}